'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Container = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding: 15px;\n    height: calc(100vh - ', 'px);\n    overflow: auto;\n    box-sizing: border-box;\n    a {\n        color: #1890ff;\n        text-decoration: none;\n        outline: none;\n        &:hover {\n            color: #007eff;\n        }\n        &:active {\n            color: #096dd9;\n        }\n    }\n    ', '\n'], ['\n    padding: 15px;\n    height: calc(100vh - ', 'px);\n    overflow: auto;\n    box-sizing: border-box;\n    a {\n        color: #1890ff;\n        text-decoration: none;\n        outline: none;\n        &:hover {\n            color: #007eff;\n        }\n        &:active {\n            color: #096dd9;\n        }\n    }\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Styled = _styledComponents2.default.div(_templateObject, function (_ref) {
    var hasButtons = _ref.hasButtons;
    return hasButtons ? 83 : 0;
}, function (_ref2) {
    var styleString = _ref2.styleString;
    return styleString;
});

var Container = exports.Container = function Container(_ref3) {
    var style = _ref3.style,
        children = _ref3.children,
        hasButtons = _ref3.hasButtons;

    return _react2.default.createElement(
        Styled,
        { styleString: style, hasButtons: hasButtons },
        children
    );
};

Container.propTypes = {
    style: _propTypes2.default.string,
    children: _propTypes2.default.node,
    hasButtons: _propTypes2.default.bool
};